import { render, staticRenderFns } from "./SaveStage.vue?vue&type=template&id=3c916610&"
import script from "./SaveStage.vue?vue&type=script&lang=js&"
export * from "./SaveStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports